import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import '../styles/VideoCarousel.css';
import { useTranslations } from '../hooks/useTranslations';

const VideoCarousel = () => {
  const { t } = useTranslations();
  const videos = [
    { id: 'QCFMcGtb9ao', titleKey: 'videoCarousel.videos.0.title', defaultTitle: 'Romanian kulttuuri – esittelyvideo 1' },
    { id: 't-9X8tF5Eyo', titleKey: 'videoCarousel.videos.1.title', defaultTitle: 'Romanian kulttuuri – esittelyvideo 2' },
    { id: 'h0U1-TqsscY', titleKey: 'videoCarousel.videos.2.title', defaultTitle: 'Romanian kulttuuri – esittelyvideo 3' },
  ];
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  const handlePrevClick = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex - 1 + videos.length) % videos.length);
  };

  const handleNextClick = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  const { id: currentVideoId, titleKey: currentTitleKey, defaultTitle } = videos[currentVideoIndex];
  const currentVideoTitle = t(currentTitleKey, defaultTitle);

  return (
    <div className="carousel-container">
      <div className="text-container">
          <h2>{t('videoCarousel.heading', 'Romanian kulttuuri')}</h2>
        <p>{t('videoCarousel.description', 'Romanialla on pitkä historia, ja se on säilyttänyt monia perinteitä ja kulttuurisia piirteitä vuosisatojen ajan. Roomalaisista juuristaan lähtien Romania on ollut kohtaamispaikka eri kulttuurien ja sivilisaatioiden välillä. Tämä näkyy monissa osissa Romanian kulttuuria, kuten sen kielessä, arkkitehtuurissa ja perinteisissä juhlissa.')}</p>
      </div>
      <div className="video-container-small">
        <iframe
          src={`https://www.youtube.com/embed/${currentVideoId}?si=VlC6T6zZnhrE3qHF`}
          title={currentVideoTitle}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
        <div className="arrow-container">
          {currentVideoIndex > 0 && (
            <button
              type="button"
              onClick={handlePrevClick}
              className="arrow-icon left-arrow"
              aria-label={t('videoCarousel.controls.previous', 'Katso edellinen video')}
            >
              <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" />
            </button>
          )}
          {currentVideoIndex < videos.length - 1 && (
            <button
              type="button"
              onClick={handleNextClick}
              className="arrow-icon right-arrow"
              aria-label={t('videoCarousel.controls.next', 'Katso seuraava video')}
            >
              <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
            </button>
          )}
        </div>
      </div>

    </div>
  );
};

export default VideoCarousel;
